import { injectable, inject } from 'inversify';
import type { IAdicionalRepository } from '@/domain/repositories/IAdicionalRepository';
import type { AdicionalFormData } from '@/domain/repositories/IAdicionalRepository';
import { Adicional } from '@/domain/entities/Adicional';
import { TYPES } from '@/di/tokens';

@injectable()
export class CreateAdicionalAction {
  constructor(
    @inject(TYPES.IAdicionalRepository)
    private adicionalRepository: IAdicionalRepository
  ) {}

  async execute(data: AdicionalFormData): Promise<Adicional> {
    return await this.adicionalRepository.create(data);
  }
}
